import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { unwrappedUserNavOverridesAtom } from '@/atoms/queries/user';
import { DATA_LOCKER_LANDING_PAGE_TAB } from '@/consts/searchKeys';
import { DataLockerSelectedTab } from '@/types/tabs';
import { BASE_CLASSIC_EXPLORE_ROUTE } from '@/utils/classicLinks';
import { useExploreNavigationItems } from './subNavigation/useExploreNavigationItems';

export const useExploreNavigationItem = () => {
  const {
    t,
    i18n: { language: locale },
  } = useTranslation('navigation');
  const isClassicPlayerScoutXp = useAtomValue(unwrappedUserNavOverridesAtom).playerScout;
  const path = isClassicPlayerScoutXp
    ? `${BASE_CLASSIC_EXPLORE_ROUTE}/men`
    : `/${locale}/data-locker${`?${DATA_LOCKER_LANDING_PAGE_TAB}=${DataLockerSelectedTab.PLAYER}`}`;

  return {
    id: 'explore',
    icon: 'IqScout' as const,
    label: t('crossPlatform.primary.explore'),
    subNav: useExploreNavigationItems(),
    path,
  };
};
